<template>
  <f7-page
    ptr
    @ptr:refresh="refreshData"
    @page:reinit="getTeamList"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        back-link-url="/bid/list">
      </f7-nav-left>
      <f7-nav-title>工友招募</f7-nav-title>
    </f7-navbar>
    <div style="position: fixed; top: 44px; left: 0.5rem; right: 0.5rem; z-index: 500;">
      <div class="toolbar tabbar">
        <div class="toolbar-inner">
          <a href="#findTeam" class="tab-link tab-link-active" @click="switchTab(0)">
            找队伍
          </a>
          <a href="#findWorker" class="tab-link" @click="switchTab(1)">
            找工友
          </a>
          <span :class="`tab-link-highlight${tabIndex}`"></span>
        </div>
      </div>
    </div>
    <div class="has-content" style="padding-top: 44px; height: 0.5rem;">
      &nbsp;
    </div>
    <f7-tabs>
      <f7-tab id="findTeam" tab-active>
        <div class="has-content" style="text-align: center;" v-if="teamList.length === 0">
          暂无队伍信息
        </div>
        <div v-else>
          <div v-for="(item, index) in teamList" :key="item.id">
            <div class="has-content" style="padding-top: 0rem; padding-bottom: 0rem;">
              <bid-team :team="item"></bid-team>
            </div>
            <div class="divider-row" v-if="index !== teamList.length - 1"></div>
          </div>
        </div>
      </f7-tab>
      <f7-tab id="findWorker">
        <div class="has-content" style="text-align: center;" v-if="workerList.length === 0">
          暂无工友信息
        </div>
        <div v-else>
          <div v-for="(item, index) in workerList" :key="item.id">
            <div class="has-content" style="padding-top: 0rem; padding-bottom: 0rem;">
              <bid-worker :worker="item" personType="workmate"></bid-worker>
            </div>
            <div class="divider-row" v-if="index !== workerList.length - 1"></div>
          </div>
        </div>
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>
<script>
import { getBidTeamList, getBidWorkerList } from '@/api/bid';
import BidTeam from '@/components/BidTeam';
import BidWorker from '@/components/BidWorker';

export default {
  components: {
    BidTeam,
    BidWorker,
  },
  data() {
    return {
      tabIndex: 0,
      teamList: [],
      teamPageObj: { page: 1, pageSize: 10 },
      workerList: [],
      workerPageObj: { page: 1, pageSize: 10 },
      allowInfinite: true,
      showPreloader: true,
      teamAllowInfinite: true,
      teamShowPreloader: true,
      workerAllowInfinite: true,
      workerShowPreloader: true,
    };
  },
  created() {
    this.getTeamList();
    this.getWorkerList();
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getTeamList(), this.getWorkerList()]).then(() => done());
    },
    switchTab(tabIndex) {
      this.tabIndex = tabIndex;
      if (this.tabIndex === 0) {
        this.allowInfinite = this.teamAllowInfinite;
        this.showPreloader = this.teamShowPreloader;
      } else if (this.tabIndex === 1) {
        this.allowInfinite = this.workerAllowInfinite;
        this.showPreloader = this.workerShowPreloader;
      }
    },
    getTeamList(pageParam) {
      this.teamPageObj = pageParam || { page: 1, pageSize: 10 };
      getBidTeamList(this.teamPageObj).then((result) => {
        if (result.code === 0) {
          if (this.teamPageObj.page === 1) {
            this.teamList = result.data || [];
          } else {
            (result.data || []).forEach((item) => {
              this.teamList.push(item);
            });
          }
          this.allowInfinite = true;
          this.teamAllowInfinite = true;
          if (this.teamList.length < 10 || (result.data || []).length === 0) {
            this.teamShowPreloader = false;
            this.teamAllowInfinite = false;
            this.showPreloader = false;
            this.allowInfinite = false;
          }
        }
      });
    },
    getWorkerList(pageParam) {
      this.workerPageObj = pageParam || { page: 1, pageSize: 10 };
      getBidWorkerList(this.workerPageObj).then((result) => {
        if (result.code === 0) {
          if (this.workerPageObj.page === 1) {
            this.workerList = result.data || [];
          } else {
            (result.data || []).forEach((item) => {
              const pos = this.workerList.findIndex(w => w.id === item.id);
              if (pos < 0) {
                this.workerList.push(item);
              } else {
                this.workerList.splice(pos, 1, item);
              }
            });
          }
          this.allowInfinite = true;
          this.workerAllowInfinite = true;
          if (this.workerList.length < 10 || (result.data || []).length === 0) {
            this.workerShowPreloader = false;
            this.workerAllowInfinite = false;
            this.showPreloader = false;
            this.allowInfinite = false;
          }
        }
      });
    },
    loadMore() {
      if (this.tabIndex === 0) {
        if (!this.teamAllowInfinite) {
          return;
        }
        this.teamAllowInfinite = false;
        if (this.teamList.length >= 100) {
          this.teamShowPreloader = false;
          return;
        }
        this.$set(this.teamPageObj, 'page', this.teamPageObj.page + 1);
        this.getTeamList(this.teamPageObj);
      } else if (this.tabIndex === 1) {
        if (!this.workerAllowInfinite) {
          return;
        }
        this.workerAllowInfinite = false;
        if (this.workerList.length >= 100) {
          this.workerShowPreloader = false;
          return;
        }
        this.$set(this.workerPageObj, 'page', this.workerPageObj.page + 1);
        this.getWorkerList(this.workerPageObj);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .menu-area {
     padding: 0.5rem 0.5rem;
     text-align: center;
  }

  .menu-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .link-menu {
    width: 4.5rem;
    height: 4.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .divider-row {
    font-size: 0.5rem;
    height: 0.5rem;
    width: 100%;
  }

  .tab-link-highlight0 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 50%;
    transform: translate3d(0%, 0px, 0px);
  }

  .tab-link-highlight1 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 50%;
    transform: translate3d(100%, 0px, 0px);
  }

</style>



// WEBPACK FOOTER //
// src/pages/bid/friendList.vue